import { ISelectOption } from 'components';

export const createOfficesArray = (offices: Record<string, number>) => {
	return Object.keys(offices).map((title) => ({
		title,
		value: title,
	})) as ISelectOption[];
};
